// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-plus-solid';

export const Component = () => (
  <path d='M23.563 4.97H10.776l-.767-2.3C9.913 2.24 9.627 2 9.1 2H.958a.946.946 0 0 0-.67.288c-.192.24-.288.478-.288.718v19.636c0 .24.096.48.287.67a.946.946 0 0 0 .67.288h22.606a.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67V5.927a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.287Zm-7.375 9.817h-3.449v3.4c0 .336-.144.527-.479.527-.335 0-.479-.191-.479-.526v-3.4H8.333c-.335 0-.48-.192-.48-.527s.145-.479.48-.479h3.448v-3.4c0-.335.144-.527.48-.527.334 0 .478.192.478.527v3.4h3.448c.336 0 .48.144.48.479 0 .335-.144.527-.48.527Z' />
);

export const viewBox = '0 0 25 25';
